import { Controller } from "@hotwired/stimulus"

const PICKUP_DELIVERY_TYPES = ['zasilkovna', 'zasilkovna_europe']

export default class extends Controller {
  static targets = ['addressFields', 'deliveryRadio', 'pickupPanel', 'pickupBranchName', 'zasilkovnaAddressId']
  static values  = { apiKey: String }

  connect() {
    this.toggleAddressFields()
  }

  toggle() {
    this.toggleAddressFields()
  }

  toggleAddressFields() {
    const selected  = this.deliveryRadioTargets.find(r => r.checked)
    const isPickup  = selected && PICKUP_DELIVERY_TYPES.includes(selected.value)

    this.addressFieldsTarget.style.display = isPickup ? 'none' : ''
    this.pickupPanelTarget.style.display   = isPickup ? ''     : 'none'
  }

  openWidget() {
    if (typeof Packeta === 'undefined') {
      console.error('Packeta widget not loaded')
      return
    }
    Packeta.Widget.pick({ apiKey: this.apiKeyValue }, (point) => {
      if (!point) return
      this.zasilkovnaAddressIdTarget.value  = point.id
      this.pickupBranchNameTarget.textContent = point.nameStreet || point.name
    })
  }
}
